import * as React from "react";
import { Form as FormikForm} from 'formik';
import { Column } from "./Column";

interface Props {
  children: React.ReactNode;
}

export const Form = ({children}: Props) => {
  return (
    <FormikForm>
      <Column>
        {children}
      </Column>
    </FormikForm>
  );
};
